import './TabStyles.css';
import {displayDateOrTimeFromFirebase} from '../../../../utils/datetime';

const ReviewsTab = ({ reviews, rating, reviewCount }) => {
    const renderStars = (rating) => {
        return Array(5).fill(0).map((_, i) => (
            <span 
                key={i} 
                className={`review-star ${i < rating ? 'review-star--filled' : ''}`}
            >
                ★
            </span>
        ));
    };

    const getRatingBreakdown = () => {
        const breakdown = [0, 0, 0, 0, 0];
        reviews.forEach(review => {
            if (review.rating >= 1 && review.rating <= 5) {
                breakdown[review.rating - 1]++;
            }
        });
        return breakdown.reverse();
    };

    const breakdown = getRatingBreakdown();
    const maxCount = Math.max(...breakdown);

    return (
        <div className="reviews-tab">
            <div className="reviews-summary">
                <div className="reviews-summary__rating">
                    <span className="reviews-summary__number">{rating}</span>
                    <div className="reviews-summary__stars">
                        {renderStars(Math.round(rating))}
                    </div>
                    <span className="reviews-summary__count">{reviewCount} reviews</span>
                </div>
                <div className="reviews-summary__breakdown">
                    {breakdown.map((count, index) => (
                        <div key={index} className="reviews-summary__bar">
                            <span className="reviews-summary__bar-label">{5 - index}</span>
                            <div className="reviews-summary__bar-track">
                                <div 
                                    className="reviews-summary__bar-fill"
                                    style={{ width: maxCount > 0 ? `${(count / maxCount) * 100}%` : '0%' }}
                                ></div>
                            </div>
                            <span className="reviews-summary__bar-count">{count}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="reviews-list">
                {reviews.map(review => (
                    <div key={review.id} className="review-card">
                        <div className="review-card__header">
                            <div className="review-card__author">
                                <span className="review-card__name">{review.author}</span>
                                {review.verified && (
                                    <span className="review-card__verified">✓ Verified Client</span>
                                )}
                            </div>
                            <span className="review-card__date">{displayDateOrTimeFromFirebase(review.date,'date')}</span>
                        </div>
                        <div className="review-card__stars">
                            {renderStars(review.rating)}
                        </div>
                        <p className="review-card__text">{review.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewsTab;
